import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import MainContentLayout from '../../../components/Layout/MainContentLayout';
import BusinessDashboard from './BusinessDashboard';

const Business = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'business'
        });
    }, []);
    return (
        <>
            <BusinessDashboard/>
        </>
    )
}

export default Business;
